import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    meta: {
      appFrame: false,
      navBar: false,
      basePath: true,
      title: "Inicio",
    },
    component: Login,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Dashboard",
      allowedRoles: ["sudo", "finance"],
    },
    component: () => import("../views/sudo/dashboard/index.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Usuarios",
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/users.vue"),
  },
  {
    path: "/donaciones",
    name: "donations",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo", "admin", "business", "finance", "client"],
      title: "Donaciones",
    },
    component: () => import("../views/donations.vue"),
  },
  {
    path: "/smsOtp",
    name: "smsOtp",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo", "admin", "business", "finance", "client"],
      title: "SMS OTP",
    },
    component: () => import("../views/smsOtp.vue"),
  },
  {
    path: "/cities",
    name: "cities",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Ciudades",
      allowedRoles: ["sudo"],
    },

    component: () => import("../views/cities.vue"),
  },
  {
    path: "/sections",
    name: "sections",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Secciones",
      allowedRoles: ["sudo"],
    },

    component: () => import("../views/sudo/sections"),
  },
  {
    path: "/campaigns",
    name: "campaigns",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Campañas",
      allowedRoles: ["sudo","partnerAdmin","admin"],
    },

    component: () => import("../views/sudo/campaigns/campaigns.vue"),
  },
  {
    path: "/partner/campaigns",
    name: "partnerCampaigns",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Campañas",
      allowedRoles: ["partnerAdmin","business"],
    },
    component: () => import("../views/partner/campaigns/campaigns.vue"),
  },

  {
      path: "/brands",
    name: "brands",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Marcas",
      allowedRoles: ["sudo"],
    },

    component: () => import("../views/sudo/brands/index.vue"),
  },
  {
    path: "/activations",
    name: "activations",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Activaciones",
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/activations/index.vue"),
  },

  {
    path: "/partner/donaciones",
    name: "partnerDonations",
    meta: {
      title: "Donaciones",
      appFrame: true,
      navBar: true,
      basePath: true,
      allowedRoles: ["partnerAdmin","business"],
    },
    component: () => import("../views/partner/donations.vue"),
  },
  // {
  //   path: '/users',
  //   name: 'users',
  //   meta: {
  //     appFrame: true,
  //     navBar: true,
  //     basePath: true,
  //     allowedRoles: ["sudo",],
  //   },

  //   component: () => import('../views/sudo/user-lists/users.vue')
  // },
  // {
  //   path: '/usersPending',
  //   name: 'usersPending',
  //   meta: {
  //     appFrame: true,
  //     navBar: true,
  //     basePath: true,
  //     allowedRoles: ["sudo",],
  //   },

  //   component: () => import('../views/sudo/user-lists/usersPending.vue')
  // },
  {
    path: "/businessPending",
    name: "businessPending",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      allowedRoles: ["sudo"],
    },

    component: () => import("../views/businessPending.vue"),
  },

  {
    path: "/usersAdmin",
    name: "usersAdmin",
    meta: {
      appFrame: true,
      navBar: true,
      basePath: true,
      title: "Usuarios Administrativos",
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/usersAdmin.vue"),
  },


  {
    path: "/paises",
    name: "paises",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Países",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/countries/countries.vue"),
  },
  {
    path: "/accessLogs",
    name: "accessLogs",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Bitácora de accesos",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/accessLogs/logs.vue"),
  },
  {
    path: "/messages",
    name: "messages",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Comentarios",
      navBar: true,
      allowedRoles: ["sudo","partnerAdmin","admin","business"],
    },
    component: () => import("../views/messages.vue"),
  },
  {
    path: "/businesses",
    name: "businesses",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Organizaciones",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/businesses/businesses.vue"),
  },
  {
    path: "/subscriptions/pixelpay",
    name: "subscriptions",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Suscripciones PixelPay",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/subscriptions/subscriptions.vue"),
  },
  {
    path: "/kyc/onboarding",
    name: "kycOnboarding",
    meta: {
      appFrame: true,
      basePath: true,
      title: "KYC Onboarding",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/kyc/onboarding.vue"),
  },
  {
    path: "/contracts",
    name: "contracts",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Contratos de campañas",
      navBar: true,
      allowedRoles: ["sudo","legal"],
    },
    component: () => import("../views/legales/contratos.vue"),
  },
  {
    path: "/finance/retiro-de-fondos",
    name: "retiro-de-fondos",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo","finance"],
      title: "Retiro de fondos",
    },
    component: () => import("../views/finance/retiro-de-fondos.vue"),
  },
  {
    path: "/finance/reportes-pago",
    name: "reportes-pago",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo","finance"],
      title: "Reportes de pago",
    },
    component: () => import("../views/finance/reportes-pago.vue"),
  },
  {
    path: "/finance/pendientes-de-pago",
    name: "pendientes-de-pago",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo","finance"],
      title: "Pendientes de pago",
    },
    component: () => import("../views/finance/pendientes-de-pago.vue"),
  },
  {
    path: "/finance/reportes-financieros",
    name: "reportes-financieros",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo","finance"],
      title: "Reportes financieros",
    },
    component: () => import("../views/finance/reportes-financieros.vue"),
  },
  {
    path: "/finance/reportes-pago-impuesto",
    name: "reportes-pago-impuesto",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo","finance"],
      title: "Reportes pago impuesto",
    },
    component: () => import("../views/finance/reportes-pago-impuesto.vue"),
  },
  {
    path: "/partner/organizations",
    name: "partnerOrganizations",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo" ,"partnerAdmin","business"],
      title: "Organizaciones",
    },
    component: () => import("../views/partner/businesses/businesses.vue"),
  },
  {
    path: "/partner/PayoutsSolicitations",
    name: "partnerPayoutsSolicitations",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["partnerAdmin","business"],
      title: "Solicitudes de retiros",
    },
    component: () => import("../views/partner/campaignPayouts/retirarFondosPage.vue"),
  },
  {
    path: "/partner/reportes-pago",
    name: "partnerReportesPago",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["partnerAdmin","business"],
      title: "Reportes de pago",
    },
    component: () => import("../views/partner/campaignPayouts/reportes-pago.vue"),
  },
  {
    path:'/driveDocuments',
    name: "driveDocuments",
    meta: {
      appFrame: true,
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/documents/FinanceLegalDrive.vue"),
  },
  {
    path: "/admin/push-notifications",
    name: "pushNotifications",
    meta: {
      appFrame: true,
      basePath: true,
      title: "Push Notifications",
      navBar: true,
      allowedRoles: ["sudo"],
    },
    component: () => import("../views/sudo/pushNotifications/index.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    meta: {
      appFrame: true,
      navBar: true,
    },
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
